import aiAPI from '@edulastic/api/src/aiAPI'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { createSelector } from 'reselect'

export const namespaceKey = 'aiPassageGeneration'

// actions constants
export const GENERATE_AI_PASSAGE = `[${namespaceKey}] generate passage`
export const SET_AI_PASSAGE_STATE = `[${namespaceKey}] set state`
export const RESET_AI_PASSAGE_STATE = `[${namespaceKey}] reset state`

// actions
export const generateAIPassageAction = (payload) => ({
  type: GENERATE_AI_PASSAGE,
  payload,
})

export const setAIPassageStateAction = (payload) => ({
  type: SET_AI_PASSAGE_STATE,
  payload,
})

export const resetAIPassageStateAction = () => ({
  type: RESET_AI_PASSAGE_STATE,
})

// selectors
export const stateSelector = (state) => state?.[namespaceKey]

export const getAIPassageState = createSelector(
  stateSelector,
  (state) => state || {}
)

// initial state
const initialState = {
  apiStatus: null,
  result: null,
  errorMessage: null,
}

// reducer
export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_AI_PASSAGE_STATE:
      return {
        ...state,
        ...payload,
      }
    case RESET_AI_PASSAGE_STATE:
      return {
        ...initialState,
      }
    default:
      return state
  }
}

// sagas
function* generateAIPassageSaga({ payload }) {
  const generalErrorMessage = 'Something went wrong'

  try {
    yield put(
      setAIPassageStateAction({
        apiStatus: 'INITIATED',
        result: null,
        errorMessage: null,
      })
    )
    const { result } = yield call(aiAPI.generatePassage, payload)
    yield put(
      setAIPassageStateAction({
        apiStatus: 'SUCCESS',
        result,
        errorMessage: null,
      })
    )
  } catch (err) {
    yield put(
      setAIPassageStateAction({
        apiStatus: 'FAILED',
        result: null,
        errorMessage: err?.message || generalErrorMessage,
      })
    )
  }
}

export function* watcherSaga() {
  yield all([takeEvery(GENERATE_AI_PASSAGE, generateAIPassageSaga)])
}
